/**
 * Bank form validation utilities
 */

import { BankDetails } from "../hooks/useBankReduxSync";

export interface BankFormErrors {
  bankName: string;
  accountHolderName: string;
  bankAddress: string;
  swiftCode: string;
  accountNumber: string;
  accountType: string;
  bankCountry: string;
  currency: string;
}

export interface ValidationResult {
  isValid: boolean;
  errors: BankFormErrors;
}

/**
 * Validate bank form fields
 * @param details - Bank details to validate
 * @returns Validation result with errors
 */
export const validateBankForm = (details: BankDetails): ValidationResult => {
  const errors: BankFormErrors = {
    bankName: "",
    accountHolderName: "",
    bankAddress: "",
    swiftCode: "",
    accountNumber: "",
    accountType: "",
    bankCountry: "",
    currency: "",
  };

  let isValid = true;

  if (!details.bankName) {
    errors.bankName = "Bank Name is required";
    isValid = false;
  }

  if (!details.accountNumber) {
    errors.accountNumber = "Account Number is required";
    isValid = false;
  }

  if (!details.accountType) {
    errors.accountType = "Account Type is required";
    isValid = false;
  }

  if (!details.swiftCode) {
    errors.swiftCode = "Swift Code is required";
    isValid = false;
  }

  if (!details.accountHolderName) {
    errors.accountHolderName = "Account Holder Name is required";
    isValid = false;
  }

  if (!details.bankAddress) {
    errors.bankAddress = "Bank Address is required";
    isValid = false;
  }

  if (!details.bankCountry) {
    errors.bankCountry = "Bank Country is required";
    isValid = false;
  }

  if (!details.currency) {
    errors.currency = "Currency is required";
    isValid = false;
  }

  return { isValid, errors };
};

/**
 * Check if account holder name matches company name
 * @param accountHolderName - Account holder name
 * @param companyName - Company name
 * @returns True if names match or company name is not provided
 */
export const validateAccountHolderNameMatchesCompany = (
  accountHolderName: string,
  companyName?: string
): boolean => {
  if (!companyName) return true;
  return accountHolderName === companyName;
};
